import { useEffect, useState } from "react";
import axiosInstance from "../config/axiosInstance";
import { COMPANY } from "../config/apiConfig";

/**
 * Contrato efetivo da empresa logada: o que o representante acima montou para
 * a carteira dele, na modalidade (pré ou pós-pago) da empresa.
 *
 * `contract` nulo tem um significado só — "usa o contrato padrão do sistema" —
 * e é o que vale tanto quando ninguém na cadeia montou contrato quanto quando
 * a chamada falha. O padrão é um documento completo e é exatamente o que o
 * cliente via antes de a configuração existir, então uma rede instável não
 * pode travar o aceite numa tela vazia.
 */
export const useEffectiveContract = (enabled = true) => {
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(!!enabled);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let aborted = false;

    (async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(COMPANY.CURRENT_CONTRACT);
        if (!aborted) setContract(data?.data?.contract || null);
      } catch (error) {
        console.error("Erro ao carregar o contrato da empresa:", error);
        if (!aborted) setContract(null);
      } finally {
        if (!aborted) setLoading(false);
      }
    })();

    return () => {
      aborted = true;
    };
  }, [enabled]);

  return { contract, loading };
};

export default useEffectiveContract;
